import { createRouter, createWebHistory } from 'vue-router'

import { appList, appConfig, appEnum } from '@/tool/appConfig'
import { usePermissionStore } from '@/store/modules/permission'
import { useLayoutStore } from '@/store/modules/layout'

import { cache } from '@/utils'
import { bus } from 'wujie'

import Layout from '@/layout'

export const appRoutes = appList.map(v => ({
  path: `/${'path' in v ? v.path : v.name}/:path(.*)*`,
  name: v.name,
  permissions: v.permissions,
  redirect: v.redirect,
  hidden: v.hidden,
  component: Layout,
  meta: {
    title: v.title,
    icon: v.icon,
    isApp: true,
    appName: v.name
  }
}))

export const routes = [
  {
    path: '/staging',
    component: Layout,
    children: [
      {
        path: '',
        name: 'StagingPage',
        component: () => import('@/views/stagingPage/index.vue'),
        meta: { title: '工作台', icon: 'svg-workbench', collapsed: true }
      }
    ]
  },
  {
    path: '/staging',
    component: Layout,
    children: [
      // {
      //   path: '',
      //   name: 'StagingPage',
      //   component: () => import('@/views/stagingPage/index.vue'),
      //   meta: { title: '工作台', icon: 'svg-workbench', collapsed: true }
      // },
      {
        path: '/accounting-redirect/:companyId',
        hidden: true,
        beforeEnter(to) {
          cache.session.set('companyId', to.params.companyId)
          bus.$emit('goApp', appEnum['accounting-system'].name)
        },
        component: { template: '<div></div>' }
      },
      {
        path: '/noticeList',
        name: 'NoticeList',
        hidden: true,
        component: () => import('@/views/stagingPage/noticeList.vue'),
        meta: { title: '公告', topBar: true }
      },
      {
        path: '/editNotice/:noticeId(.*)*',
        name: 'EditNotice',
        hidden: true,
        permissions: 'system:notice:setting',
        component: () => import('@/views/stagingPage/handleNotice.vue'),
        meta: { title: '编辑公告', topBar: true }
      },
      {
        path: '/createNotice/:noticeId(.*)*',
        name: 'CreateNotice',
        hidden: true,
        permissions: 'system:notice:setting',
        component: () => import('@/views/stagingPage/handleNotice.vue'),
        meta: { title: '发布公告', topBar: true, backOption: { visible: true, backApp: true } }
      },
      {
        path: '/noticePreview',
        name: 'NoticePreview',
        hidden: true,
        component: () => import('@/views/stagingPage/noticePreviewDetail.vue'),
        meta: { title: '公告预览', topBar: true }
      },
      // {
      //   path: '/noticePreview/:handle(.*?)/:noticeId(.*)*',
      //   name: 'NoticePreview',
      //   hidden: true,
      //   component: () => import('@/views/stagingPage/noticeManageDetail.vue'),
      //   meta: { title: '公告预览', topBar: true }
      // },
      {
        path: '/noticeDetail',
        name: 'NoticeDetail',
        hidden: true,
        component: () => import('@/views/stagingPage/noticeDetail.vue'),
        meta: { title: '公告详情', topBar: true, backOption: { visible: true, backApp: true }}
      },
      {
        path: '/invoice',
        name: 'Invoice',
        hidden: true,
        component: () => import('@/views/stagingPage/invoice.vue'),
        meta: { title: '发票识别', topBar: true, collapsed: true}
      },
      {
        path: '/license',
        name: 'License',
        hidden: true,
        component: () => import('@/views/stagingPage/license.vue'),
        meta: { title: '营业执照识别', topBar: true, collapsed: true}
      },
      {
        path: '/idCard',
        name: 'IdCard',
        hidden: true,
        component: () => import('@/views/stagingPage/idCard.vue'),
        meta: { title: '身份证识别', topBar: true, collapsed: true}
      },
      {
        path: '/bankCard',
        name: 'BankCard',
        hidden: true,
        component: () => import('@/views/stagingPage/bankCard.vue'),
        meta: { title: '银行卡识别', topBar: true, collapsed: true}
      },
      {
        path: '/universalIdentification',
        name: 'UniversalIdentification',
        hidden: true,
        component: () => import('@/views/stagingPage/universalIdentification.vue'),
        meta: { title: '通用识别', topBar: true, collapsed: true}
      },
      {
        path: '/faceRecognition',
        name: 'FaceRecognition',
        hidden: true,
        component: () => import('@/views/stagingPage/faceRecognition.vue'),
        meta: { title: '人脸识别', topBar: true, collapsed: true}
      },
      {
        path: '/tableIdentify',
        name: 'TableIdentify',
        hidden: true,
        component: () => import('@/views/stagingPage/tableIdentify.vue'),
        meta: { title: '表格识别', topBar: true, collapsed: true}
      },
      {
        path: '/noticeManageDetail/:noticeId(.*)*',
        name: 'NoticeManageDetail',
        hidden: true,
        component: () => import('@/views/stagingPage/noticeManageDetail.vue'),
        meta: { title: '公告详情', topBar: true, backOption: { visible: true, backApp: true }}
      }
    ]
  },
  {
    path: '/noticeManage',
    component: Layout,
    children: [
      {
        path: '',
        name: 'NoticeManage',
        hidden: true,
        components: {
          default: () => import('@/views/stagingPage/noticeManage.vue')
        },
        meta: {
          title: '公告管理',
          topBar: true,
          backOption: { visible: true, backApp: true }
        }
      }
    ]
  },
  // {
  //   path: '/invoice',
  //   component: Layout,
  //   children: [
  //     {
  //       path: '',
  //       name: 'invoice',
  //       hidden: true,
  //       components: {
  //         default: () => import('@/views/stagingPage/noticeManage.vue')
  //       },
  //       meta: {
  //         title: '发票识别',
  //         topBar: true,
  //         backOption: { visible: true, backApp: true }
  //       }
  //     }
  //   ]
  // },
  {
    path: '/message',
    component: Layout,
    children: [
      {
        path: '',
        name: 'MessagePage',
        component: () => import('@/views/messagePage/index.vue'),
        meta: { title: '消息', icon: 'svg-message', collapsed: true }
      }
    ]
  },
  {
    path: '/instantMessage',
    component: Layout,
    children: [
      {
        path: '',
        name: 'InstantMessagePage',
        component: () => import('@/views/messagePage/instant.vue'),
        meta: { title: '即时通讯', icon: 'svg-jishiotngxun', collapsed: true }
      }
    ]
  },
  {
    path: '/approve',
    component: Layout,
    children: [
      {
        path: 'status/:status?/processInstanceId/:processInstanceId?/taskId/:taskId?',
        name: 'ApprovalPage',
        component: () => import('@/views/approvalPage/index.vue'),
        meta: { title: '审批', icon: 'svg-alarm', collapsed: true }
      }
    ]
  },
  {
    path: '/personal',
    component: Layout,
    hidden: true,
    redirect: '/personal/personal-center',
    children: [
      {
        path: 'personal-center',
        name: 'PersonalCenter',
        component: () => import('@/views/personalPage/personalCenter.vue'),
        meta: { title: '个人中心' }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(`/${(appConfig.routerBase || '').replace(/^\//, '')}`),
  routes: [
    { path: '/login', name: 'Login', component: () => import('@/views/loginPage/index.vue') },
    { path: '/changePassword', name: 'ChangePassword', component: () => import('@/views/loginPage/changePassword.vue') },
    { path: '/forceChangePassword', name: 'ForceChangePassword', component: () => import('@/views/loginPage/changePassword.vue') },
    { path: '/501', name: '501', component: () => import('@fe/zxwy-utils/page/v-errorPage/501Page.vue') },
    { path: '/401', name: '401', component: () => import('@fe/zxwy-utils/page/v-errorPage/401Page.vue') },
    {
      path: '',
      component: Layout,
      redirect: '/staging',
      children: [
        { path: '/:pathMatch(.*)*', name: '404Page', component: () => import('@fe/zxwy-utils/page/v-errorPage/404Page.vue') }
      ]
    }
  ]
})

const whiteRoutes = [
  '/401', '/501'
]

router.beforeEach((to, from, next) => {
  if (to.fullPath === '/staging') {
    bus.$emit('destroy', from.name)
  }
  const layoutStore = useLayoutStore()

  if(from.fullPath.includes('GoodsDetail')) {
    const newStr = from.fullPath.match(/\/[^/]*$/)[0]

    layoutStore.updateRouteNames(to.fullPath, newStr, 'GoodsDetail')
  }
  const { isGenerate, isComplex } = usePermissionStore()

  // 白名单
  if (whiteRoutes.includes(to.path)) return next()

  if (isGenerate) {
    // 登录页重定向验证
    if (to.path === '/login') return next(decodeURIComponent(to.query.redirect) || '/')

    // 未重置密码 强制前往重置密码
    if (!isComplex && to.name !== 'ForceChangePassword') {
      return next({ name: 'ForceChangePassword', query: { redirect: encodeURIComponent(to.fullPath) }})
    }

    // 已登录
    return next()
  }

  // 获取用户信息
  usePermissionStore().getPermission().then(() => {
    // 生成显示路由
    useLayoutStore().addRoutes()
    next(to.fullPath)
  }).catch(() => {
    console.warn('Not Logged In')
    usePermissionStore().logout()
    if (to.name === 'Login') return next()
    next({ path: '/login', query: { redirect: to.query.redirect || encodeURIComponent(to.fullPath) }})
  })
})

export default router
